export default [
	{
		name: "login",
		path: "/login",
		component: () => import("@/view/login/Login"),
		// 창 제목: "Dot Apps : " + 번역한 '로그인' (router/index.js getRouteTitle)
		meta: { layout: "BlankLayout", leftMenu: "false", titleKey: "로그인" }
    },
	{
		name: "login-callback",
		path: "/login-callback",
		component: () => import("@/view/login/LoginCallback"),
		meta: { layout: "BlankLayout", leftMenu: "false", titleKey: "로그인" }
    }
]